<template>
  <q-dialog v-model="visible" transition-show="scale" transition-hide="scale">
    <div class="hris-modal">
      <div class="hris-modal-header">
        <div>
          <h2 class="hris-modal-title">Deduction History</h2>
          <p class="hris-modal-subtitle">Total Deduction: <span class="text-weight-bold" style="color: var(--hris-accent);">{{ totaldeductionHistory }}</span></p>
        </div>
      </div>
      <div class="hris-modal-body">
        <div v-if="deductionHistory.length <= 0" class="hris-empty">No Deduction Yet!</div>
        <q-list v-else separator>
          <q-item v-for="(deduct, index) in deductionHistory" :key="index">
            <q-item-section>
              <q-item-label>{{ deduct.noOfDeduction }} Deduction</q-item-label>
              <q-item-label caption>Paydate:
                <span class="text-weight-bold text-green">{{ deduct.paydate }}</span>
              </q-item-label>
              <q-item-label caption>Cutt Off:
                <span class="text-weight-bold text-green">{{ deduct.cuttOff }}</span>
              </q-item-label>
              <q-item-label caption>Amount:
                <span class="text-weight-bold text-green">{{ deduct.amountDeduct }}</span>
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
    </div>
  </q-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    deductionHistory: Array,
    totaldeductionHistory: [Number, String]
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  }
}
</script>
